import { ResponseStatus } from "@/domain/entities/agenda/AgendaItemResponseStatus";
import { cn } from "@/lib/utils";

const getClassNameFromUserAcceptedStatus = (
    userAcceptedStatus: ResponseStatus,
) =>
    cn(
        userAcceptedStatus === ResponseStatus.Accepted
            ? "border border-primary-dark bg-surface-calendarEventDark text-white [&_a]:text-blue-300 [&_.scrollbar-thumb]:bg-purple-400"
            : "",
        userAcceptedStatus === ResponseStatus.TentativelyAccepted
            ? "border border-dashed border-white bg-surface-calendarEventDark text-white [&_a]:text-blue-300 [&_.scrollbar-thumb]:bg-purple-400 "
            : "",
        userAcceptedStatus === ResponseStatus.None &&
            "border border-purple-700 [&_.event-footer]:border-purple-700 [&_.meeting-link-button]:border-purple-700",
    );

export default getClassNameFromUserAcceptedStatus;
